import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withKeys as _withKeys, renderSlot as _renderSlot, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e7dcc49"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "W-100 D-Flex"
}
const _hoisted_3 = ["contenteditable"]
const _hoisted_4 = { class: "W-100 D-Flex" }
const _hoisted_5 = {
  style: {"margin-inline-end":"1em","margin-inline-start":"1em","height":"1.5em","align-items":"center","gap":"0.5em","width":"100%"},
  class: "F-Bold M-Auto D-Flex"
}
const _hoisted_6 = {
  key: 0,
  style: {"margin-block-start":"0em"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "M-Auto" }, null, -1))
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { key: 6 }
const _hoisted_12 = { key: 7 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "ReportTable"
}
const _hoisted_15 = {
  key: 1,
  class: "NOPRINT",
  style: {"max-width":"70%"}
}
const _hoisted_16 = { class: "W-100 D-Flex" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["Tooltip", "onClick"]
const _hoisted_19 = ["Tooltip", "onClick"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 0,
  style: {"margin-inline-start":"0.75em"}
}
const _hoisted_22 = {
  key: 1,
  style: {"margin-inline-start":"0.75em"}
}
const _hoisted_23 = ["Tooltip", "onClick"]
const _hoisted_24 = ["Tooltip", "onClick"]
const _hoisted_25 = ["Tooltip", "onClick"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = ["Tooltip", "onClick"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = ["Tooltip", "onClick"]
const _hoisted_30 = ["Tooltip"]
const _hoisted_31 = ["href"]
const _hoisted_32 = ["onKeydown", "onBlur", "Tooltip", "onClick", "contenteditable", "onVnodeMounted", "innerHTML"]
const _hoisted_33 = ["Tooltip", "onClick"]
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = {
  key: 0,
  style: {"margin-inline-start":"0.75em"}
}
const _hoisted_36 = {
  key: 1,
  style: {"margin-inline-start":"0.75em"}
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = ["ToolTip", "onMousedown", "onTouchstart"]
const _hoisted_39 = {
  key: 1,
  class: "ReportTable"
}
const _hoisted_40 = ["colspan"]
const _hoisted_41 = {
  key: 0,
  style: {"flex-wrap":"wrap","display":"flex","gap":"0.5em"}
}
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  key: 1,
  class: "W-100 D-Flex"
}
const _hoisted_45 = {
  style: {"margin-inline-end":"1em","margin-inline-start":"1em","height":"1.5em","align-items":"center","gap":"0.5em","width":"100%"},
  class: "F-Bold M-Auto D-Flex"
}
const _hoisted_46 = {
  key: 0,
  style: {"margin-block-start":"0em"}
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "M-Auto" }, null, -1))
const _hoisted_48 = { key: 2 }
const _hoisted_49 = { key: 4 }
const _hoisted_50 = { key: 5 }
const _hoisted_51 = { key: 6 }
const _hoisted_52 = { key: 7 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesLoading = _resolveComponent("CookiesLoading")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesSortingTH = _resolveComponent("CookiesSortingTH")!
  const _component_Waypoint = _resolveComponent("Waypoint")!
  const _component_CookiesNumberInput = _resolveComponent("CookiesNumberInput")!
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!
  const _component_vueQr = _resolveComponent("vueQr")!

  return (_ctx.TableSettings && _ctx.TableSettings.CookiesID)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "mainTableC",
        onTouchmove: _cache[1] || (_cache[1] = ($event: any) => (_ctx.IsTouching($event))),
        onMousemove: _cache[2] || (_cache[2] = ($event: any) => (_ctx.IsMoving($event))),
        style: _normalizeStyle([_ctx.Grapping !== null ? 'cursor: grab !important;' : '', {"border-radius":"0.5em","width":"100%"}]),
        id: _ctx.TableSettings.CookiesID
      }, [
        (!_ctx.TableSettings.HideTableName && _ctx.TableSettings.Header)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", {
                contenteditable: _ctx.TableSettings.TableNameEditable,
                style: {"margin-bottom":"0.5em"},
                class: "M-Auto F1_5em F-Bold"
              }, _toDisplayString(_ctx.TableSettings.TableName), 9, _hoisted_3)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.Loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.Translate('loading')), 1))
              : _createCommentVNode("", true),
            (_ctx.Loading)
              ? (_openBlock(), _createBlock(_component_CookiesLoading, {
                  key: 1,
                  class: "F_75em",
                  style: {"height":"auto","width":"auto","margin-block-start":"0em"}
                }))
              : _createCommentVNode("", true),
            _hoisted_7,
            (_ctx.Saving)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.Translate('saving')), 1))
              : _createCommentVNode("", true),
            (_ctx.Saving)
              ? (_openBlock(), _createBlock(_component_CookiesLoading, {
                  key: 3,
                  class: "F_75em",
                  style: {"height":"auto","width":"auto"}
                }))
              : _createCommentVNode("", true),
            ((_ctx.Saved === true))
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.Translate('saved')), 1))
              : _createCommentVNode("", true),
            ((_ctx.Saved === true))
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _createVNode(_component_CookiesIcon, {
                    class: "SQR1_5em",
                    ID: ('Done' as IconsIDs)
                  }, null, 8, ["ID"])
                ]))
              : _createCommentVNode("", true),
            ((_ctx.Saved === false))
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.Translate('error in saving')), 1))
              : _createCommentVNode("", true),
            ((_ctx.Saved === false))
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _createVNode(_component_CookiesIcon, {
                    class: "SQR1_5em BlackWhite",
                    ID: ('Removed' as IconsIDs)
                  }, null, 8, ["ID"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("table", {
          class: _normalizeClass(["Cookies_Table1 W-100 TableBG TablePrint", _ctx.ErrorData ? 'ErrorBorder Rad2' : '']),
          cellpading: "0",
          cellspacing: "0",
          style: {"border-collapse":"collapse","page-break-inside":"auto !important"}
        }, [
          _createElementVNode("tr", {
            class: _normalizeClass([_ctx.TableSettings.PrintControls ? '' : 'D-None', "noprint PRINTROW ReportTable"]),
            style: {"background":"none"}
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FilteredFields, (field) => {
              return (_openBlock(), _createElementBlock("th", {
                class: "Printtoggle ReportTable",
                style: {"background":"none"},
                key: (field.Name)
              }, [
                (!(field.NoPrint === true || field.Type === 'selector' || field.Type === 'index'))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["Pointer", _ctx.DeepFetcher(_ctx.PrintStatus, field.Name) && 'noprint']),
                      onClick: ($event: any) => (_ctx.ChangePrintState(field.Name))
                    }, [
                      _createVNode(_component_CookiesIcon, {
                        style: {"width":"1.3em","height":"1.3em"},
                        class: "M-Auto",
                        ID: 'Printer'
                      })
                    ], 10, _hoisted_13))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 2),
          (_ctx.TableSettings.Header !== false)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FilteredFields, (field) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: field }, [
                    (field.Type !== 'selector')
                      ? (_openBlock(), _createBlock(_component_CookiesSortingTH, {
                          key: 0,
                          class: _normalizeClass(["ReportTable", [_ctx.DeepFetcher(_ctx.PrintStatus, field.Name) && 'noprint', (field.NoPrint) && 'NOPRINT',field.Sort && 'sotrableheader']]),
                          onClick: ($event: any) => (field.Sort && _ctx.SortTable(field.Sort, 'SortElement')),
                          Sortable: field.Sort !== undefined,
                          Name: field.NoHeader ? '' : _ctx.Translate(field.Name),
                          Value: field.Value,
                          SearchRes: field.IsSearchable ? 'PrintTableFieldSearch_' + field.Name : undefined,
                          sortColumn: _ctx.SortElement
                        }, null, 8, ["class", "onClick", "Sortable", "Name", "Value", "SearchRes", "sortColumn"]))
                      : _createCommentVNode("", true),
                    (field.Type === 'selector')
                      ? (_openBlock(), _createElementBlock("th", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_CookiesIcon, {
                              onClick: ($event: any) => (_ctx.SelectAll(field)),
                              class: "SQR1_5em M-Auto HoverGlow",
                              ID: ('Select' as IconsIDs)
                            }, null, 8, ["onClick", "ID"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                (_ctx.TableSettings.Sorter)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_17))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.VisibleData, (element, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: _normalizeClass(["ReportTable", [_ctx.SelectorField && (_ctx.RowSelectCheck(element) ? '' : ' O-50 noprint ')]]),
              ref_for: true,
              ref: 'Row_' + _ctx.DeepFetcher(element, 'OriginalIndex'),
              key: (_ctx.DeepFetcher(element, 'OriginalIndex')),
              style: _normalizeStyle([_ctx.GrappedItem.OriginalIndex === element.OriginalIndex ? 'filter: drop-shadow(var(--shadow1)); background:' + _ctx.Theme.BG2Fixed + '; z-index: 100; transform-origin: right; transform: scale(1.05);' : '', _ctx.Grapping !== null ? 'pointer-events: none;' : ''])
            }, [
              (_ctx.TableSettings.InfiniteScroller)
                ? (_openBlock(), _createBlock(_component_Waypoint, {
                    key: 0,
                    onChange: ($event: any) => (_ctx.SenseElement($event, index))
                  }, null, 8, ["onChange"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FilteredFields, (field) => {
                return (_openBlock(), _createElementBlock("td", {
                  style: _normalizeStyle([{"height":"inherit"}, field.Type === 'selector' ? 'width: 2em; padding-inline-start: 1em;' : '' + field.Style + _ctx.RowFinder(element)]),
                  class: _normalizeClass(["ReportTable", [field.Bold && 'F-Bold', _ctx.DeepFetcher(_ctx.PrintStatus, field.Name) && 'noprint', (field.Type === 'selector' || field.NoPrint) && 'NOPRINT', field.Editable ? 'EditableCell': '', field.CellDynamicClass && _ctx.DynamicCalculator(element, field, 'CellDynamicClass') && field.CellDynamicClass.ClassList]]),
                  key: (field.Name)
                }, [
                  (field.Type === 'index')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        Tooltip: field.ToolTip,
                        onClick: ($event: any) => (field.Function ? _ctx.$emit(field.Function, element, _ctx.DeepFetcher(element ,'OriginalIndex')) : undefined)
                      }, _toDisplayString(index + 1), 9, _hoisted_18))
                    : _createCommentVNode("", true),
                  (field.Type === 'normal' && !field.Editable)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        Tooltip: field.ToolTip,
                        onClick: ($event: any) => (field.Function ? _ctx.$emit(field.Function, element, _ctx.DeepFetcher(element ,'OriginalIndex')) : undefined),
                        style: {"overflow-wrap":"normal"}
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass([field.Class, field.RelativeClass && _ctx.RelativeClass(field, element), field.DynamicClass && _ctx.DynamicCalculator(element, field, 'DynamicClass') && field.DynamicClass.ClassList]),
                          innerHTML: typeof _ctx.DeepFetcher(element, field.Value) === 'number' ? _ctx.DecimalFixer(_ctx.DeepFetcher(element, field.Value)) : _ctx.DeepFetcher(element, field.Value)
                        }, null, 10, _hoisted_20),
                        (_ctx.DeepFetcher(element, field.Value) && field.Unit)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(field.Unit), 1))
                          : _createCommentVNode("", true),
                        (_ctx.DeepFetcher(element, field.Value) && field.DynamicUnit)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.DeepFetcher(element, field.DynamicUnit)), 1))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_19))
                    : _createCommentVNode("", true),
                  (field.Type === 'Image')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        class: _normalizeClass([field.Class, field.RelativeClass && _ctx.RelativeClass(field, element), field.DynamicClass && _ctx.DynamicCalculator(element, field, 'DynamicClass') && field.DynamicClass.ClassList]),
                        Tooltip: field.ToolTip,
                        onClick: ($event: any) => (field.Function ? _ctx.$emit(field.Function, element, _ctx.DeepFetcher(element ,'OriginalIndex')) : undefined),
                        style: {"text-align":"-webkit-center"}
                      }, [
                        _createElementVNode("div", {
                          class: "SQR2_5em TableImage",
                          style: _normalizeStyle('background-image: url(' + _ctx.DefaultImageHandler(_ctx.DeepFetcher(element, field.Value)) + ')')
                        }, null, 4)
                      ], 10, _hoisted_23))
                    : _createCommentVNode("", true),
                  (field.Type === 'datetime')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 3,
                        class: _normalizeClass([field.Class, field.RelativeClass && _ctx.RelativeClass(field, element), field.DynamicClass && _ctx.DynamicCalculator(element, field, 'DynamicClass') && field.DynamicClass.ClassList]),
                        Tooltip: field.ToolTip,
                        onClick: ($event: any) => (field.Function ? _ctx.$emit(field.Function, element, _ctx.DeepFetcher(element ,'OriginalIndex')) : undefined)
                      }, _toDisplayString(_ctx.DateFormatter(_ctx.DeepFetcher(element, field.Value), 'DD/MM/YYYY | FullDay')), 11, _hoisted_24))
                    : _createCommentVNode("", true),
                  (field.Type === 'numberInput')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 4,
                        class: _normalizeClass([field.Class, field.RelativeClass && _ctx.RelativeClass(field, element), field.DynamicClass && _ctx.DynamicCalculator(element, field, 'DynamicClass') && field.DynamicClass.ClassList]),
                        Tooltip: field.ToolTip,
                        onClick: ($event: any) => (field.Function ? _ctx.$emit(field.Function, element, _ctx.DeepFetcher(element ,'OriginalIndex')) : undefined)
                      }, [
                        (field.Res_ID)
                          ? (_openBlock(), _createBlock(_component_CookiesNumberInput, {
                              key: 0,
                              style: {"font-size":"0.95em"},
                              Min: field.numberInput_Min !== undefined ? typeof field.numberInput_Min === 'number'? field.numberInput_Min : _ctx.DeepFetcher(element, field.numberInput_Min) : -99999999,
                              Max: field.numberInput_Max !== undefined ? typeof field.numberInput_Max === 'number'? field.numberInput_Max : _ctx.DeepFetcher(element, field.numberInput_Max) : 99999999,
                              Unit: field.Unit,
                              Step: field.numberInput_Step,
                              Buttons: field.numberInput_Buttons === false ? false : true,
                              onChanged: ($event: any) => (_ctx.$emit('InputChanged', { field, element })),
                              Default: _ctx.DeepFetcher(element, field.Value) ? _ctx.DeepFetcher(element, field.Value) : field.numberInput_Default,
                              Res: _ctx.TableSettings.CookiesID + '_Edited_' + field.Name + '_' + _ctx.DeepFetcher(element, field.Res_ID),
                              PreserveMemory: false
                            }, null, 8, ["Min", "Max", "Unit", "Step", "Buttons", "onChanged", "Default", "Res"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.Translate('No Res_ID')), 1))
                      ], 10, _hoisted_25))
                    : _createCommentVNode("", true),
                  (field.Type === 'checkBox')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 5,
                        class: _normalizeClass([field.Class, field.RelativeClass && _ctx.RelativeClass(field, element), field.DynamicClass && _ctx.DynamicCalculator(element, field, 'DynamicClass') && field.DynamicClass.ClassList]),
                        Tooltip: field.ToolTip,
                        onClick: ($event: any) => (field.Function ? _ctx.$emit(field.Function, element, _ctx.DeepFetcher(element ,'OriginalIndex')) : undefined)
                      }, [
                        (field.Res_ID)
                          ? (_openBlock(), _createBlock(_component_CookiesCheckBox, {
                              key: 0,
                              style: {"font-size":"0.95em"},
                              Type: 'Check',
                              onChanged: ($event: any) => (_ctx.$emit('InputChanged', { field, element })),
                              Default: field.checkBox_Default ? field.checkBox_Default : _ctx.DeepFetcher(element, field.Value) ? true : false,
                              Res: _ctx.TableSettings.CookiesID + '_Edited_' + field.Name + '_' + _ctx.DeepFetcher(element, field.Res_ID),
                              PreserveMemory: false,
                              Name: ''
                            }, null, 8, ["onChanged", "Default", "Res"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.Translate('No Res_ID')), 1))
                      ], 10, _hoisted_27))
                    : _createCommentVNode("", true),
                  (field.Type === 'delete')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 6,
                        class: _normalizeClass([field.Class, field.RelativeClass && _ctx.RelativeClass(field, element), field.DynamicClass && _ctx.DynamicCalculator(element, field, 'DynamicClass') && field.DynamicClass.ClassList]),
                        Tooltip: field.ToolTip,
                        onClick: ($event: any) => (field.Function ? _ctx.$emit(field.Function, element, _ctx.DeepFetcher(element ,'OriginalIndex')) : undefined)
                      }, [
                        _createVNode(_component_CookiesIcon, {
                          onClick: ($event: any) => (_ctx.$emit('DeleteRow', element, _ctx.DeepFetcher(element ,'OriginalIndex'))),
                          Tooltip: field.ToolTip ? undefined : _ctx.Translate('Delete'),
                          title: _ctx.Translate('Delete'),
                          class: "M-Auto Pointer",
                          style: {"width":"1.5em","height":"1.5em"},
                          ID: 'Delete'
                        }, null, 8, ["onClick", "Tooltip", "title"])
                      ], 10, _hoisted_29))
                    : _createCommentVNode("", true),
                  (field.Type === 'icon')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 7,
                        class: _normalizeClass([field.Class, field.RelativeClass && _ctx.RelativeClass(field, element), field.DynamicClass && _ctx.DynamicCalculator(element, field, 'DynamicClass') && field.DynamicClass.ClassList]),
                        Tooltip: field.ToolTip
                      }, [
                        (_ctx.DeepFetcher(element, field.Value))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              target: "_blank",
                              href: _ctx.DeepFetcher(element, field.Value)
                            }, [
                              _createVNode(_component_CookiesIcon, {
                                onClick: ($event: any) => (field.Function ? _ctx.$emit(field.Function, element, _ctx.DeepFetcher(element ,'OriginalIndex')) : undefined),
                                class: "M-Auto Pointer",
                                style: {"width":"1.5em","height":"1.5em"},
                                ID: field.Icon_isDynamic ? _ctx.DeepFetcher(element, field.Value) : field.Unit
                              }, null, 8, ["onClick", "ID"])
                            ], 8, _hoisted_31))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_30))
                    : _createCommentVNode("", true),
                  (field.Editable)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 8,
                        onKeydown: _withKeys(($event: any) => (!field.Editable_Multiline && $event.preventDefault()), ["enter"]),
                        "on:Paste": _cache[0] || (_cache[0] = ($event: any) => (_ctx.PasteFixer($event, true))),
                        onBlur: ($event: any) => (_ctx.TextChanged((_ctx.TableSettings.CookiesID + '_Edited_' + field.Name + '_' + _ctx.DeepFetcher(element, field.Res_ID ? field.Res_ID : '')), $event, field, element)),
                        class: _normalizeClass([[field.Class], "EditableDiv"]),
                        style: {},
                        Tooltip: field.ToolTip,
                        onClick: ($event: any) => (field.Function ? _ctx.$emit(field.Function, element, _ctx.DeepFetcher(element ,'OriginalIndex')) : undefined),
                        EditableCell: true,
                        contenteditable: field.Editable,
                        onVnodeMounted: ($event: any) => (_ctx.MEMWrite(_ctx.TableSettings.CookiesID + '_Edited_' + field.Name + '_' + _ctx.DeepFetcher(element, field.Res_ID ? field.Res_ID : ''), _ctx.DeepFetcher(element, field.Value))),
                        innerHTML: field.Res_ID ? _ctx.$store.state.CookiesMemory[_ctx.TableSettings.CookiesID + '_Edited_' + field.Name + '_' + _ctx.DeepFetcher(element, field.Res_ID)] : ''
                      }, null, 42, _hoisted_32))
                    : _createCommentVNode("", true),
                  ((field.Type === 'array-normal' || field.Type === 'array-datetime') && _ctx.TableSettings.MultiLevel)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 9,
                        class: _normalizeClass([[field.Class, field.RelativeClass && _ctx.RelativeClass(field, element), field.DynamicClass && _ctx.DynamicCalculator(element, field, 'DynamicClass') && field.DynamicClass.ClassList], "ItemLister"])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DeepFetcher(element, field.Value), (item) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "M-Auto",
                            key: item
                          }, [
                            (field.Type === 'array-normal')
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  Tooltip: field.ToolTip,
                                  onClick: ($event: any) => (field.Function ? _ctx.$emit(field.Function, element, _ctx.DeepFetcher(element ,'OriginalIndex')) : undefined),
                                  style: {"overflow-wrap":"normal"}
                                }, [
                                  _createElementVNode("span", {
                                    innerHTML: typeof _ctx.DeepFetcher(item, field.MultiValue ? field.MultiValue : 'Name') === 'number' ? _ctx.DecimalFixer(_ctx.DeepFetcher(item, field.MultiValue ? field.MultiValue : 'Name')) : _ctx.DeepFetcher(item, field.MultiValue ? field.MultiValue : 'Name')
                                  }, _toDisplayString(), 9, _hoisted_34),
                                  (_ctx.DeepFetcher(item, field.MultiValue ? field.MultiValue : 'Name') && field.Unit)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(field.Unit), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.DeepFetcher(item, field.MultiValue ? field.MultiValue : 'Name') && field.DynamicUnit)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.DeepFetcher(item, field.DynamicUnit)), 1))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_33))
                              : _createCommentVNode("", true),
                            (field.Type === 'array-datetime')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.JsonDateParser(_ctx.DeepFetcher(item, field.MultiValue ? field.MultiValue : 'Name')) + ' | ' + _ctx.JsonTimeParser(_ctx.DeepFetcher(item, field.MultiValue ? field.MultiValue : 'Name'))), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ], 2))
                    : _createCommentVNode("", true),
                  ((field.Type === 'array-normal' || field.Type === 'array-datetime') && !_ctx.TableSettings.MultiLevel)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 10,
                        class: _normalizeClass([[field.Class, field.RelativeClass && _ctx.RelativeClass(field, element), field.DynamicClass && _ctx.DynamicCalculator(element, field, 'DynamicClass') && field.DynamicClass.ClassList], "ItemLister"])
                      }, [
                        _createElementVNode("span", null, "(" + _toDisplayString(_ctx.DeepFetcher(element, field.Value).length) + ")", 1)
                      ], 2))
                    : _createCommentVNode("", true),
                  (field.Type === 'QR' && _ctx.DeepFetcher(element, field.Value))
                    ? (_openBlock(), _createBlock(_component_vueQr, {
                        key: 11,
                        class: _normalizeClass([[field.Class, field.RelativeClass && _ctx.RelativeClass(field, element), field.DynamicClass && _ctx.DynamicCalculator(element, field, 'DynamicClass') && field.DynamicClass.ClassList], "Rad1 M-Auto"]),
                        Tooltip: field.ToolTip,
                        onClick: ($event: any) => (field.Function ? _ctx.$emit(field.Function, element, _ctx.DeepFetcher(element ,'OriginalIndex')) : undefined),
                        style: _normalizeStyle([{"width":"10em"}, field.QR_Style ? field.QR_Style : '']),
                        text: _ctx.DeepFetcher(element, field.Value),
                        size: field.QR_Size ? field.QR_Size : 300
                      }, null, 8, ["class", "Tooltip", "onClick", "style", "text", "size"]))
                    : _createCommentVNode("", true),
                  (field.Type === 'selector')
                    ? (_openBlock(), _createBlock(_component_CookiesCheckBox, {
                        key: 12,
                        class: _normalizeClass([field.Class, field.RelativeClass && _ctx.RelativeClass(field, element), field.DynamicClass && _ctx.DynamicCalculator(element, field, 'DynamicClass') && field.DynamicClass.ClassList]),
                        Tooltip: field.ToolTip,
                        Res: _ctx.TableSettings.CookiesID + '_selector_' + _ctx.DeepFetcher(element, field.Res_ID ? field.Res_ID : ''),
                        Default: _ctx.MEMRead(_ctx.TableSettings.CookiesID + '_selector_' + _ctx.DeepFetcher(element, field.Res_ID ? field.Res_ID : '')) ? _ctx.MEMRead(_ctx.TableSettings.CookiesID + '_selector_' + _ctx.DeepFetcher(element, field.Res_ID ? field.Res_ID : '')) : field.selector_Default ? _ctx.DeepFetcher(element, field.selector_Default) : _ctx.TableSettings.TableSelectDefaults === false ? false : true
                      }, null, 8, ["class", "Tooltip", "Res", "Default"]))
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, "default", {
                    class: _normalizeClass([field.Class, field.RelativeClass && _ctx.RelativeClass(field, element), field.DynamicClass && _ctx.DynamicCalculator(element, field, 'DynamicClass') && field.DynamicClass.ClassList]),
                    field: field,
                    element: element
                  }, undefined, true)
                ], 6))
              }), 128)),
              (_ctx.TableSettings.Sorter)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 1,
                    ToolTip: _ctx.Translate('Sort'),
                    onMousedown: ($event: any) => (_ctx.Grapped($event, element, 'Mouse')),
                    onTouchstart: ($event: any) => (_ctx.Grapped($event, element, 'Touch')),
                    class: "Pointer F-Bold O-50 F1_5em",
                    style: {"user-select":"none","cursor":"grab","width":"1.5em"}
                  }, "=", 40, _hoisted_38))
                : _createCommentVNode("", true)
            ], 6))
          }), 128)),
          (_ctx.SearchedData.length === 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                _createElementVNode("td", {
                  class: "O-50 tdFull",
                  colspan: _ctx.TableSettings.Sorter ? _ctx.FilteredFields.length + 1 : _ctx.FilteredFields.length
                }, _toDisplayString(_ctx.Translate('No Data Avilable')), 9, _hoisted_40)
              ]))
            : _createCommentVNode("", true),
          (_ctx.SearchedData.length > 0 && _ctx.TableSettings.Footer)
            ? (_openBlock(), _createElementBlock("tr", {
                key: 2,
                class: _normalizeClass([!_ctx.TableSettings.Footer && 'NOPRINT D-None', "ReportTable TableFooter"])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FilteredFields, (field) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: _normalizeClass([[field.Bold && 'F-Bold', field.Class, _ctx.DeepFetcher(_ctx.PrintStatus, field.Name) && 'noprint', (field.Type === 'selector' || field.NoPrint) && 'NOPRINT'], "TableFooter ReportTable"]),
                    key: (field.Name),
                    style: {"border":"none"}
                  }, [
                    (field.Total)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.Translate('Total')), 1),
                          _createTextVNode(" ("),
                          _createElementVNode("span", {
                            innerHTML: _ctx.TotalOF(field)
                          }, null, 8, _hoisted_42),
                          _createTextVNode(") ")
                        ]))
                      : _createCommentVNode("", true),
                    (field.Type === 'selector')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createElementVNode("span", null, _toDisplayString('( '+_ctx.DecimalFixer(_ctx.TableValue.length)+' )'), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ], 2))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.CookiesData.length > 15)
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                (_ctx.Loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.Translate('loading')), 1))
                  : _createCommentVNode("", true),
                (_ctx.Loading)
                  ? (_openBlock(), _createBlock(_component_CookiesLoading, {
                      key: 1,
                      class: "F_75em",
                      style: {"height":"auto","width":"auto","margin-block-start":"0em"}
                    }))
                  : _createCommentVNode("", true),
                _hoisted_47,
                (_ctx.Saving)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.Translate('saving')), 1))
                  : _createCommentVNode("", true),
                (_ctx.Saving)
                  ? (_openBlock(), _createBlock(_component_CookiesLoading, {
                      key: 3,
                      class: "F_75em",
                      style: {"height":"auto","width":"auto"}
                    }))
                  : _createCommentVNode("", true),
                ((_ctx.Saved === true))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.Translate('saved')), 1))
                  : _createCommentVNode("", true),
                ((_ctx.Saved === true))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                      _createVNode(_component_CookiesIcon, {
                        class: "SQR1_5em",
                        ID: ('Done' as IconsIDs)
                      }, null, 8, ["ID"])
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.Saved === false))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.Translate('error in saving')), 1))
                  : _createCommentVNode("", true),
                ((_ctx.Saved === false))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                      _createVNode(_component_CookiesIcon, {
                        class: "SQR1_5em BlackWhite",
                        ID: ('Removed' as IconsIDs)
                      }, null, 8, ["ID"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 44, _hoisted_1))
    : _createCommentVNode("", true)
}